/* eslint-disable */
let API_HOSTNAME = 'https://api.minapoli.com/api'
let HOSTNAME = 'http://staging-frontend.minapoli.com'

if (process.env.NODE_ENV === 'staging') {
  API_HOSTNAME = 'https://staging-api.minapoli.com/api'
  HOSTNAME = 'http://staging-frontend.minapoli.com'
}

if (process.env.NODE_ENV === 'production') {
  API_HOSTNAME = 'https://api.minapoli.com/api'
  HOSTNAME = 'http://minapoli.com'
}

export {
  API_HOSTNAME,
  HOSTNAME,
}



// WEBPACK FOOTER //
// ./src/GlobalConfig.js